import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'trackerManagementExperience.listExport'

const TrackerManagementTrackerListExportSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default TrackerManagementTrackerListExportSlice
